import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { vinelandConfig } from "./data";

export default function VinelandPage() {
  return <CityPageTemplate config={vinelandConfig} />;
}